import { MovementCarrierPay } from "../../../powerbroker/src/MovementCarrierPay";
import { Button, Checkbox, DataSource, HorizontalSpacer, Label, Layout, Location, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBillingRates extends Layout {
    buttonCreateTax: Button;
    buttonEditMaxTotal: Button;
    buttonEditTargetTotal: Button;
    buttonEstimateFuelSurcharge: Button;
    buttonExpandCharges: Button;
    buttonExpandDetails: Button;
    buttonExpandTaxes: Button;
    buttonRate: Button;
    checkboxLockMiles: Checkbox;
    chevronSpacer2: HorizontalSpacer;
    chevronSpacer3: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    labelAdditionalCharges: Label;
    labelAutoRated: Label;
    labelFreightCharge: Label;
    labelRatingDetails: Label;
    labelTaxCharge: Label;
    labelTaxesHeader: Label;
    labelTotalCharge: Label;
    layoutMovementRates: MovementCarrierPay;
    panelAllocation: Panel;
    panelChevron2: Panel;
    panelChevron3: Panel;
    panelChevron: Panel;
    panelExciseTaxTotal: Panel;
    panelFreightCharge: Panel;
    panelOrderCarrierPay: Panel;
    panelOrderMaxPay: Panel;
    panelOrderRates: Panel;
    panelOrderTargetPay: Panel;
    panelOtherChargeTable: Panel;
    panelOtherCharges: Panel;
    panelOtherChargesHeader2: Panel;
    panelOtherChargesHeader: Panel;
    panelRateTotals: Panel;
    panelRatesHeader: Panel;
    panelRatingDetails: Panel;
    panelRatingDetailsHeader2: Panel;
    panelRatingDetailsHeader: Panel;
    panelRatingDetailsTable: Panel;
    panelReviewAdditionalCharges: Panel;
    panelReviewFreightCharge: Panel;
    panelReviewTotalCharges: Panel;
    panelSwitchSpacer: Panel;
    panelTaxTable: Panel;
    panelTaxes: Panel;
    panelTaxesContent: Panel;
    panelTaxesHeader: Panel;
    panelTaxesHeaderTitle: Panel;
    panelTotalWithTaxes: Panel;
    sourceBilling: DataSource;
    sourceDistanceAlert: DataSource;
    sourceExcisetaxChargeBill: DataSource;
    sourceOrders: DataSource;
    sourceOtherChargeBill: DataSource;
    sourceRatingDetails: DataSource;
    sourceRatingDetailsSummary: DataSource;
    spacerRatingDetailsHeader: HorizontalSpacer;
    switchByFreightItem: Switch;
    switchExciseDisableUpdate: Switch;
    switchTaxableOrder: Switch;
    tableOtherCharges: Table;
    tableRevPerFgi: Table;
    tableRevSummary: Table;
    tableTax: Table;
    textboxBillDistance: Textbox;
    textboxCollectionMethod: Textbox;
    textboxCtrlParty: Location;
    textboxCurrencyType: Textbox;
    textboxExcisetaxTotal: Textbox;
    textboxFreightCharge2: Textbox;
    textboxFreightCharge: Textbox;
    textboxMaxMargin: Textbox;
    textboxMaxMarginPercent: Textbox;
    textboxMaxPay: Textbox;
    textboxOtherchargetotal: Textbox;
    textboxPieces: Textbox;
    textboxRate: Textbox;
    textboxRateMinWeight: Textbox;
    textboxRateType: Textbox;
    textboxRateUnitDesc: Textbox;
    textboxRateUnits: Textbox;
    textboxSegAllocCode: Textbox;
    textboxTargetMarginAmount: Textbox;
    textboxTargetMarginPercent: Textbox;
    textboxTargetPay: Textbox;
    textboxTotalCharge: Textbox;
    textboxTotalWithTax: Textbox;
    textboxWeight: Textbox;
}
